export default __webpack_public_path__ + "static/media/edital092024final.f7ead054.pdf";